export interface ErrorInfo {
  type: 'session_expired' | 'network_error' | 'backend_error' | 'access_restricted';
  title: string;
  message: string;
  icon: string;
}


export const categorizeError = (error: any): ErrorInfo => {
  if (!error.response) {
    if (error.message && (error.message.includes('Network Error') || error.message.includes('network'))) {
      return {
        type: 'network_error',
        title: 'Connection Issue',
        message: 'It seems your internet connection is unstable. Please check your connection and try again.',
        icon: 'WarningCircle'
      };
    }
    
    return {
      type: 'network_error',
      title: 'Session Expired',
      message: 'The link expired. Please contact us to proceed.',
      icon: 'WarningCircle'
    };
  }

  const status = error.response?.status;
  const errorData = error.response?.data;
  const requestUrl = error.config?.url || error.request?.responseURL || '';

  if (status === 401 || status === 307) {
    if (status === 307 && requestUrl.includes('validate-token')) {
      return {
        type: 'session_expired',
        title: 'Session Expired',
        message: 'This link expired. Please contact us to proceed.',
        icon: 'Hourglass'
      };
    }

    const errorMessage = errorData?.detail || errorData?.message || '';
    if (
      errorMessage.toLowerCase().includes('expired') ||
      errorMessage.toLowerCase().includes('token') ||
      errorMessage.toLowerCase().includes('session') ||
      errorMessage.toLowerCase().includes('invalid token') ||
      errorMessage.toLowerCase().includes('link expired')
    ) {
      return {
        type: 'session_expired',
        title: 'Session Expired',
        message: 'This link expired. Please contact us to proceed.',
        icon: 'Hourglass'
      };
    }
    
    return {
      type: 'access_restricted',
      title: 'Access Restricted',
      message: errorMessage || "You don't have access to this form.",
      icon: 'WarningCircle'
    };
  }

  if (status === 403) {
    return {
      type: 'access_restricted',
      title: 'Access Restricted',
      message: errorData?.detail || errorData?.message || "You don't have access to this form.",
      icon: 'WarningCircle'
    };
  }

  if (status >= 500) {
    return {
      type: 'backend_error',
      title: 'Something Went Wrong',
      message: 'Something went wrong on our side. Please try again later.',
      icon: 'Danger-Circle'
    };
  }

  const backendMessage = errorData?.detail || errorData?.message || errorData?.error || '';
  
  if (backendMessage) {
    return {
      type: 'backend_error',
      title: 'Error',
      message: `We encountered an error: ${backendMessage}`,
      icon: 'Danger-Circle'
    };
  }

  return {
    type: 'backend_error',
    title: 'Something Went Wrong',
    message: 'Something went wrong on our side. Please try again later.',
    icon: 'Danger-Circle'
  };
};

